import { gql } from '@apollo/client'

export const OPERATION_SEND_EMAIL_CONFIRMATION = gql`
  mutation sendEmailConfirmation($id: ID!) {
    recovery: sendEmailConfirmation(id: $id) {
      status
    }
  }
`

export const OPERATION_FAKE = gql`
  mutation Fake($email: String!) {
    me: fake(email: $email) {
      access_token
      refresh_token
    }
  }
`

const OPERATION_UPDATE_PERMISSIONS = gql`
  mutation UpdatePermissions($sf_id: String!, $admin: Boolean!, $roles: Roles) {
    updatePermissions(sf_id: $sf_id, admin: $admin, roles: $roles) {
      sf_id
      roles
    }
  }
`

export const OPERATION_DISABLE_CONTACT = gql`
  mutation disableContact($sf_id: String!) {
    disableContact(sf_id: $sf_id) {
      status
    }
  }
`

export const OPERATION_REACTIVATE_CONTACT = gql`
  mutation reactivateContact($sf_id: String!) {
    reactivateContact(sf_id: $sf_id) {
      status
    }
  }
`

export const OPERATION_SYNCHRONIZE = gql`
  mutation synchronizeContacts($sf_ids: [ID]!, $roles: Roles!) {
    result: synchronizeContacts(sf_ids: $sf_ids, roles: $roles) {
      status
    }
  }
`

export const OPERATION_ADD_REMOVE_ROLES_PER_BATCH = gql`
  mutation addRemoveRolesPerBatch($user_ids: [ID]!, $roles_to_add: [String], $roles_to_remove: [String]) {
    result: addRemoveRolesPerBatch(user_ids: $user_ids, roles_to_add: $roles_to_add, roles_to_remove: $roles_to_remove) {
      status
    }
  }
`

export const OPERATION_ACTIVATE_DEACTIVATE_PER_BATCH = gql`
  mutation activateDeactivatePerBatch($user_ids: [ID]!, $action_type: String!) {
    result: activateDeactivatePerBatch(user_ids: $user_ids, action_type: $action_type) {
      status
    }
  }
`

export const OPERATION_RESEND_CONFIRMATION_PER_BATCH = gql`
  mutation resendConfirmationPerBatch($user_ids: [ID]!) {
    result: resendConfirmationPerBatch(user_ids: $user_ids) {
      status
    }
  }
`

export default OPERATION_UPDATE_PERMISSIONS
